import script from "./AudioInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioInput.vue?vue&type=script&setup=true&lang=js"

import "./AudioInput.vue?vue&type=style&index=0&id=95c6a460&lang=scss"

const __exports__ = script;

export default __exports__